// extracted by mini-css-extract-plugin
export var blob = "portfolio-module--blob--80bb2";
export var blurb = "portfolio-module--blurb--95536";
export var content = "portfolio-module--content--86c7b";
export var dots = "portfolio-module--dots--ca140";
export var header = "portfolio-module--header--4e1f5 header-module--banner--fcf6f";
export var site = "portfolio-module--site--4866d";
export var sites = "portfolio-module--sites--fd866";
export var squiggle_1 = "portfolio-module--squiggle_1--8dd42";
export var squiggle_2 = "portfolio-module--squiggle_2--21981";